import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(undefined, async (err) => {
  const cfg = err.config;
  if (err.response?.status === 401 && cfg && !cfg._retry && !cfg.url.startsWith("/auth/") && !cfg.url.startsWith("/customer/")) {
    cfg._retry = true;
    refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
    try { await refreshing; return api(cfg); } catch { /* fall through */ }
  }
  return Promise.reject(err);
});

export const apiError = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Si è verificato un errore";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
};

export const formatPrice = (v) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(v);

let waNumber = "393246941767";
export const setWaNumber = (n) => { if (n) waNumber = n; };
export const waLink = (text) => `https://wa.me/${waNumber}?text=${encodeURIComponent(text)}`;

export const WA_MESSAGES = {
  prodotto: "Buongiorno, vorrei ricevere informazioni su un prodotto BDC-Boutique.",
  ordine: "Buongiorno, ho bisogno di assistenza per un ordine BDC-Boutique.",
  spedizioni: "Buongiorno, vorrei informazioni sulle spedizioni BDC-Boutique.",
};

export const productWaMessage = (p) =>
  `Buongiorno, vorrei informazioni sul prodotto "${p.name}" (SKU: ${p.sku}).`;
